import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const chromeStyles: IStyles = {
    chrome: {
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 6,
    },
    plus: {
        position: 'absolute',
        width: 18,
        height: 18,
        borderRadius: '50%',
        border: `1px solid ${color.blue}`,
        background: color.bgWhitePrimary,
        color: color.blue,
        fontSize: 14,
        lineHeight: '16px',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        pointerEvents: 'auto',
        boxShadow: `0 1px 4px ${color.bgAlphaDark50}`,
        zIndex: 2,

        '&:hover': {
            background: color.blue,
            color: color.bgWhitePrimary,
        },
    },
    borderHandle: {
        position: 'absolute',
        pointerEvents: 'auto',
        zIndex: 1,
        background: 'transparent',

        '&:hover': {
            background: color.blue200,
        },
    },
    borderHandleRow: {
        left: 0,
        right: 0,
        height: 6,
        marginTop: -3,
        cursor: 'row-resize',
    },
    borderHandleCol: {
        top: 0,
        bottom: 0,
        width: 6,
        marginLeft: -3,
        cursor: 'col-resize',
    },
}

addStyles(chromeStyles)
export default chromeStyles
